<div class="d-flex">
    <div class="container-box mx-auto" [ngStyle]="{'width': width, 'height': height, 'margin-top': marginTop, 'margin-bottom': marginBottom}">
        <ng-content></ng-content>
    </div>
</div>

